export function stringToBoolean(str: string): boolean {
  return str === 'true'
}
